import { observer } from 'mobx-react'
import React from 'react'

import { ExtendedColumnKey } from '@new/__global/components/FiltersFramework'
import {
  ExtendedColumnCell,
  ExtendedHeaderGroupCell,
} from '@new/domains/fastBookingsTapeChart/__commonStyles'
import { arrivalModeColumnStore } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/components/ArrivalModeColumns/ArrivalModeColumnStore'
import { CaseTabs } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/components/ArrivalsChecklistSidePanel/ArrivalsChecklist.types'
import { ExtendedColumnGroups } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/ExtendedColumns.types'
import { HomeExtendedInfo } from '@new/domains/fastBookingsTapeChart/stores/FastBookingsTapeChartStore'

import { CheckListStatus } from './CheckListStatus'

const columnWidth = 50

export const CasesStatusHeader = () => {
  return (
    <ExtendedHeaderGroupCell
      key={`col-header-${ExtendedColumnKey.casesStatus}`}
      width={columnWidth}
    >
      Cases
    </ExtendedHeaderGroupCell>
  )
}

const CasesStatusCell = observer(({ home }: { home?: HomeExtendedInfo }) => {
  if (!home?.id) return <ExtendedColumnCell width={columnWidth}>-</ExtendedColumnCell>

  const otherCaseDetails = arrivalModeColumnStore.homeStatuses.get(home.id)?.othersCasesDetails
  const checklistStatus = otherCaseDetails?.status
  const hasCases = (otherCaseDetails?.total ?? 0) > 0
  const completedCasesIds =
    otherCaseDetails?.completed.map(currentCase => currentCase.workOrderId) ?? []
  const openCases = otherCaseDetails?.cases
    ? otherCaseDetails.cases.filter(
        currentCase => !completedCasesIds.includes(currentCase.workOrderId),
      )
    : []
  const caseWithHighOrUrgentPriorityCount =
    openCases.filter(currentCase => currentCase.isHighOrUrgentPriority).length ?? 0

  return (
    <CheckListStatus
      caseTab={CaseTabs.fieldOps}
      checklistStatus={checklistStatus}
      columnWidth={columnWidth}
      hasCases={hasCases}
      caseWithHighOrUrgentPriorityCount={caseWithHighOrUrgentPriorityCount}
      home={home}
      openCaseCount={openCases ? openCases.length : undefined}
    />
  )
})

export const CasesStatus = {
  header: <CasesStatusHeader />,
  columnKey: ExtendedColumnKey.casesStatus,
  groupId: ExtendedColumnGroups.arrivalsChecklist,
  width: columnWidth,
  renderer: (home?: HomeExtendedInfo) => (
    <CasesStatusCell key={`col-${ExtendedColumnKey.casesStatus}-${home?.id}`} home={home} />
  ),
}
